import GrmMediaStreamTrackGenerator from '@/lib/gooroomee/track-generator/GrmMediaStreamTrackGenerator'
import GrmMediaStreamTrackCanvas from '@/lib/gooroomee/track-generator/GrmMediaStreamTrackCanvas'
import GrmMediaStreamTrackCanvasWorker from '@/lib/gooroomee/track-generator/GrmMediaStreamTrackCanvasWorker'
import GrmMediaStreamTrackGeneratorWorker from "@/lib/gooroomee/track-generator/GrmMediaStreamTrackGeneratorWorker";

export default class GrmMediaStreamTrack {
  static create (options, options2={}) {
    let type = options2.type;

    let App;
    switch(type){
      case 'trackGenerator':
        App = GrmMediaStreamTrackGenerator;
        break;
      case 'trackGeneratorWorker':
        App = GrmMediaStreamTrackGeneratorWorker;
        break;
      case 'canvas':
        App = GrmMediaStreamTrackCanvas;
        break;
      case 'workerCanvas':
      case 'canvasWorker':
        App = GrmMediaStreamTrackCanvasWorker;
        break;
    }

    if(App && App.isSupported()){
      return new App(options);
    }

    if(GrmMediaStreamTrackGenerator.isSupported()){
      App = GrmMediaStreamTrackGeneratorWorker;
    }else if(GrmMediaStreamTrackCanvasWorker.isSupported()){
      App = GrmMediaStreamTrackCanvasWorker;
    }else{
      App = GrmMediaStreamTrackCanvas;
    }
    return new App(options);
  }
}